import { takeLatest } from 'redux-saga/effects';
import {
  CREATE_EXCEL_TAX_RATE_REQUEST,
  DELETE_EXCEL_TAX_RATE_REQUEST,
  DELETE_TAX_RATE_TEMPLATE_REQUEST,
  EDIT_TAX_RATE_TEMPLATE_NAME_REQUEST,
  FETCH_TAX_RATES_BY_COUNTRY_REQUEST,
  GET_TAX_RATE_TEMPLATES_REQUEST,
  SAVE_TAX_RATE_TEMPLATE_REQUEST,
  SAVE_TAX_RATES_REQUEST,
  UPDATE_EXCEL_TAX_RATE_NAME_REQUEST,
  REFRESH_CONNECTION_TAX_RATES_REQUEST,
} from '../constants';
import { saveTaxRateTemplateSaga } from './saveTaxRateTemplateSaga';
import { getTaxRateTemplatesSaga } from './getTaxRateTemplatesSaga';
import { deleteTaxRateTemplateSaga } from './deleteTaxRateTemplateSaga';
import { deleteExcelTaxRateSaga } from './deleteExcelTaxRateSaga';
import { editTaxRateTemplateNameSaga } from './editTaxRateTemplateNameSaga';
import { fetchTaxRatesByCountrySaga } from './fetchTaxRatesByCountrySaga';
import { saveTaxRatesSaga } from './saveTaxRatesSaga';
import { updateExcelTaxRateNameSaga } from './updateExcelTaxRateNameSaga';
import { createExcelTaxRateSaga } from './createExcelTaxRateSaga';
import { refreshConnectionTaxRatesSaga } from './refreshConnectionTaxRatesSaga';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* taxRatesSaga() {
  yield takeLatest(SAVE_TAX_RATE_TEMPLATE_REQUEST, saveTaxRateTemplateSaga);
  yield takeLatest(GET_TAX_RATE_TEMPLATES_REQUEST, getTaxRateTemplatesSaga);
  yield takeLatest(
    DELETE_TAX_RATE_TEMPLATE_REQUEST,
    deleteTaxRateTemplateSaga
  );
  yield takeLatest(DELETE_EXCEL_TAX_RATE_REQUEST, deleteExcelTaxRateSaga);
  yield takeLatest(
    UPDATE_EXCEL_TAX_RATE_NAME_REQUEST,
    updateExcelTaxRateNameSaga
  );
  yield takeLatest(CREATE_EXCEL_TAX_RATE_REQUEST, createExcelTaxRateSaga);
  yield takeLatest(
    EDIT_TAX_RATE_TEMPLATE_NAME_REQUEST,
    editTaxRateTemplateNameSaga
  );
  yield takeLatest(
    FETCH_TAX_RATES_BY_COUNTRY_REQUEST,
    fetchTaxRatesByCountrySaga
  );
  yield takeLatest(SAVE_TAX_RATES_REQUEST, saveTaxRatesSaga);
  yield takeLatest(
    REFRESH_CONNECTION_TAX_RATES_REQUEST,
    refreshConnectionTaxRatesSaga
  );
}

